import type { Metadata } from "@/lib/head";
import { Link } from "@/lib/nav";

import CustomerScreenShell from "@/components/customer-screen-shell";
import { formatDate } from "@buildpy/core/lib/format";
import { statementGroupingOf } from "@buildpy/core/modules/change-order/current-statement";
import CustomerStatementView from "@/modules/change-order/ui/customer-statement-view";
import { DEMO_AWAITING, DEMO_CONTRACT_NO, DEMO_ORG, DEMO_TITLE, DEMO_TODAY, demoStatement } from "@buildpy/core/modules/demo/data";
import { DEMO_PATH, DEMO_TOKEN, demoStatementPath } from "@buildpy/core/modules/demo/routes";
import PrintButton from "@/modules/print/print-button";
import CustomerHeadOrg from "@/modules/share/ui/customer-head-org";

export const metadata: Metadata = {
  title: "현재 내역서 데모",
  robots: { index: false, follow: true },
};

interface Props {
  searchParams?: { [key: string]: string | string[] | undefined };
}

// 고객 현재 내역서(/c/[token]/statement) 데모 — 승인된 변경공사 1차가 반영되고 2차는 확인 대기로 남는다.
const Page = ({ searchParams }: Props) => {
  const statement = demoStatement(statementGroupingOf(searchParams?.by));

  return (
    <CustomerScreenShell className="p-0 pb-10">
      <header className="print-hide sticky top-(--safe-top) z-10 flex flex-wrap items-center justify-between gap-2 border-b border-border bg-card px-4 py-2.5">
        <CustomerHeadOrg name={DEMO_ORG.name} tel={DEMO_ORG.tel} />
        <div className="flex shrink-0 items-center gap-x-3">
          <Link className="tap-target relative text-sm text-muted-foreground underline-offset-2 hover:underline" href={DEMO_PATH.project}>
            내 현장
          </Link>
          <PrintButton label="인쇄" variant="outline" />
        </div>
      </header>

      <CustomerStatementView
        asOf={formatDate(DEMO_TODAY)}
        awaiting={DEMO_AWAITING}
        contractHref={DEMO_PATH.project}
        contractNo={DEMO_CONTRACT_NO}
        contractTitle={DEMO_TITLE}
        groupingHref={demoStatementPath}
        statement={statement}
        token={DEMO_TOKEN}
      />
    </CustomerScreenShell>
  );
};

export default Page;
